module.exports = __webpack_public_path__ + "img/mehmet-kirci@2x.57f29436.png";